"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRIMITIVE_MODE = void 0;
var PRIMITIVE_MODE;
(function (PRIMITIVE_MODE) {
    PRIMITIVE_MODE[PRIMITIVE_MODE["POINTS"] = 0] = "POINTS";
    PRIMITIVE_MODE[PRIMITIVE_MODE["LINES"] = 1] = "LINES";
    PRIMITIVE_MODE[PRIMITIVE_MODE["LINE_LOOP"] = 2] = "LINE_LOOP";
    PRIMITIVE_MODE[PRIMITIVE_MODE["LINE_STRIP"] = 3] = "LINE_STRIP";
    PRIMITIVE_MODE[PRIMITIVE_MODE["TRIANGLES"] = 4] = "TRIANGLES";
    PRIMITIVE_MODE[PRIMITIVE_MODE["TRIANGLE_STRIP"] = 5] = "TRIANGLE_STRIP";
    PRIMITIVE_MODE[PRIMITIVE_MODE["TRIANGLE_FAN"] = 6] = "TRIANGLE_FAN";
})(PRIMITIVE_MODE || (exports.PRIMITIVE_MODE = PRIMITIVE_MODE = {}));
//# sourceMappingURL=IGeometryData.js.map